import messages_DE from './de_DE.json';
import messages_GB from './en_GB.json';
import messages_ES from './es_ES.json';
import messages_PT from './pt_PT.json';

const flattenObj = (translations) => {
    const result = {};

    for (const translationsKey in translations) {
        if ((typeof translations[translationsKey]) === 'object' && !Array.isArray(translations[translationsKey])) {
            const nextedTranslations = flattenObj(translations[translationsKey]);
            for (const key in nextedTranslations) {
                result[translationsKey + '.' + key] = nextedTranslations[key];
            }
        } else {
            result[translationsKey] = translations[translationsKey];
        }
    }
    return result;
};


export const messages = {
    'de_DE': flattenObj(messages_DE),
    'en_GB': flattenObj(messages_GB),
    'es_ES': flattenObj(messages_ES),
    'pt_PT': flattenObj(messages_PT)
};
